import { EuiSpacer } from '@elastic/eui';
import PrivacyTable from 'components/Web_User_Interface/720p_Series/Multimedia/Privacy_Mask/privacyTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  PrivacyTable,
  BreadCrumbs,
  SEOHelmet,
  React
};